import React, { createContext, useContext, useState } from 'react';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [showCreatePost, setShowCreatePost] = useState(false);

  const openCreatePost = () => setShowCreatePost(true);
  const closeCreatePost = () => setShowCreatePost(false);

  return (
    <UIContext.Provider value={{ showCreatePost, openCreatePost, closeCreatePost }}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) throw new Error('useUI must be used within UIProvider');
  return context;
};